import React, { ReactNode, Suspense, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'

import WaitlistContainer from '../Waitlist/Waitlist.container'
import LoginContainer from '../../pages/Login/Login.container'
import SignUpContainer from '../../pages/SignUp/SignUp.container'
import ApplicationContainer from '../../pages/Application/Application.container'
import ForgotPasswordContainer from '../../pages/ForgotPassword/ForgotPassword.container'
import QualifyingDevice from '../../pages/QualifyingDevice/QualifyingDevice.container'
import DownloadAppContainer from '../../pages/DownloadApp/DownloadApp.container'

import { useApp } from '../AppContext/AppProvider'
import { useAuth } from '../AuthContext/AuthProvider'
import { getJwt } from '../../services/user.session.service'
import { APP_PATHS } from './types'

const Secure: React.FC<{ children: ReactNode }> = ({
  children
}): JSX.Element => {
  const { user } = useAuth()
  const location = useLocation()
  const jwt = getJwt()

  if (!user && !jwt) {
    return (
      <Navigate to={APP_PATHS.LOGIN_IN} state={{ from: location }} replace />
    )
  }

  return <>{children}</>
}

/**
 * Good docs here https://reactrouter.com/docs/en/v6/getting-started/overview
 * @returns
 */
const AppRouterContainer: React.FC = (): JSX.Element => {
  const { authorizationError } = useApp()
  const { logout } = useAuth()

  useEffect(() => {
    if (authorizationError) logout()
  }, [authorizationError])

  return (
    <Suspense fallback={<></>}>
      <Routes>
        {/* non secure routes */}
        <Route path={APP_PATHS.MAIN} element={<WaitlistContainer />} />
        <Route path={APP_PATHS.SIGN_UP} element={<SignUpContainer />} />
        <Route path={APP_PATHS.LOGIN_IN} element={<LoginContainer />} />
        <Route
          path={APP_PATHS.FORGOT_PASSWORD}
          element={<ForgotPasswordContainer />}
        />
        <Route
          path={APP_PATHS.QUALIFYING_DEVICE}
          element={<QualifyingDevice />}
        />
        <Route
          path={APP_PATHS.DOWNLOAD_APP}
          element={<DownloadAppContainer />}
        />

        {/* secure routes */}
        <Route
          path={APP_PATHS.APPLICATION}
          element={
            <Secure>
              <ApplicationContainer />
            </Secure>
          }
        />

        {/* catch-all */}
        <Route path="*" element={<WaitlistContainer />} />
      </Routes>
    </Suspense>
  )
}

export default AppRouterContainer
